import {
  CustomIconName,
  Exercise,
  Level,
  Phase,
  ScheduleEntryColourCode,
  SessionSequence,
  UserExerciseSession,
  WorkoutSettings,
} from '../../entities';
import { ISessionSequenceStrategy } from './isessionsequencestrategy';
import MachineWording from './machineWording';

export class MachineEndAndStretch implements ISessionSequenceStrategy {
  public getSessionSequence(
    exercise: Exercise,
    alernativeExercise: Exercise,
    secondAternativeExercise: Exercise,
    thirdAlternateExercise: Exercise,
    zone: number,
    quarter: number,
    level?: Level,
    workoutSettings?: WorkoutSettings,
    previousExerciseSessions?: UserExerciseSession[],
    exerciseFormatDescription?: string,
    loop?: number,
  ): SessionSequence[] {
    const endWorkoutInProgressText = MachineWording.progress.endsIn;
    const exitInProgressText = MachineWording.progress.exitIn;
    const displayText = previousExerciseSessions
      && previousExerciseSessions[0].parentWorkoutSession.areaCategory === 'power'
      ? MachineWording.powerEndWorkout
      : MachineWording.endWorkout;

    const repeatingPerformanceMetricSequenceEntry = {
      durationInMilliseconds: 10,
      videoFile: '',
      exerciseVersion: '',
      displayName: '',
      displayBurnOrBuildIcon: false,
      progressColourCode: ScheduleEntryColourCode.Rest,
      progressText: exitInProgressText,
      showProcessedMetrics: true,
      showCalculatedMetrics: true,
      tips: Exercise.getFormattedTips(exercise),
      phase: Phase.MachineEnd,
      zone,
    };

    const repeatingExitTextSequenceEntry = {
      durationInMilliseconds: 5,
      videoFile: '',
      exerciseVersion: '',
      displayName: MachineWording.exit,
      displayBurnOrBuildIcon: false,
      progressColourCode: ScheduleEntryColourCode.Prepare,
      progressText: exitInProgressText,
      showProcessedMetrics: false,
      showCalculatedMetrics: false,
      customIcon: CustomIconName.Exit,
      tips: Exercise.getFormattedTips(exercise),
      phase: Phase.MachineEnd,
      zone,
    };

    return [{
      durationInMilliseconds: 5,
      sequence: [{
        durationInMilliseconds: 5,
        videoFile: '',
        exerciseVersion: '',
        displayName: MachineWording.lastMinute,
        displayBurnOrBuildIcon: false,
        customIcon: CustomIconName.StartingBell,
        progressColourCode: ScheduleEntryColourCode.Play,
        progressText: endWorkoutInProgressText,
        showProcessedMetrics: false,
        showCalculatedMetrics: false,
        tips: Exercise.getFormattedTips(exercise),
        phase: Phase.Train,
        zone,
      }],
    }, {
      durationInMilliseconds: 45,
      sequence: [{
        durationInMilliseconds: 45,
        videoFile: '',
        exerciseVersion: '',
        displayName: '',
        displayBurnOrBuildIcon: false,
        progressColourCode: ScheduleEntryColourCode.Play,
        progressText: endWorkoutInProgressText,
        showProcessedMetrics: false,
        showCalculatedMetrics: true,
        tips: Exercise.getFormattedTips(exercise),
        phase: Phase.Train,
        zone,
      }],
    }, {
      durationInMilliseconds: 10,
      sequence: [{
        durationInMilliseconds: 10,
        videoFile: '',
        exerciseVersion: '',
        displayName: MachineWording.stretch,
        displayBurnOrBuildIcon: false,
        customIcon: CustomIconName.StartingBell,
        progressColourCode: ScheduleEntryColourCode.Play,
        progressText: endWorkoutInProgressText,
        showProcessedMetrics: false,
        showCalculatedMetrics: false,
        tips: Exercise.getFormattedTips(exercise),
        phase: Phase.Train,
        zone,
      }],
    }, {
      durationInMilliseconds: 10,
      sequence: [{
        durationInMilliseconds: 10,
        videoFile: '',
        exerciseVersion: '',
        displayName: displayText,
        displayBurnOrBuildIcon: false,
        customIcon: CustomIconName.PrepareWorkout,
        progressColourCode: ScheduleEntryColourCode.Prepare,
        progressText: exitInProgressText,
        showProcessedMetrics: false,
        showCalculatedMetrics: false,
        tips: Exercise.getFormattedTips(exercise),
        phase: Phase.MachineEnd,
        zone,
      }],
    }, {
      durationInMilliseconds: 10,
      sequence: [repeatingPerformanceMetricSequenceEntry],
    }, {
      durationInMilliseconds: 5,
      sequence: [repeatingExitTextSequenceEntry],
    }, {
      durationInMilliseconds: 10,
      sequence: [repeatingPerformanceMetricSequenceEntry],
    }, {
      durationInMilliseconds: 5,
      sequence: [repeatingExitTextSequenceEntry],
    }, {
      durationInMilliseconds: 10,
      sequence: [repeatingPerformanceMetricSequenceEntry],
    }, {
      durationInMilliseconds: 10,
      sequence: [{
        durationInMilliseconds: 10,
        videoFile: '',
        exerciseVersion: '',
        displayName: MachineWording.makeWay,
        displayBurnOrBuildIcon: false,
        customIcon: CustomIconName.StartingBell,
        progressColourCode: ScheduleEntryColourCode.Prepare,
        progressText: exitInProgressText,
        showProcessedMetrics: false,
        showCalculatedMetrics: false,
        tips: Exercise.getFormattedTips(exercise),
        phase: Phase.MachineEnd,
        zone,
      }],
    }];
  }
}
